<template>
<!-- Created with Inkscape (http://www.inkscape.org/) -->

<svg
   version="1.1"
   id="svg4047"
   xml:space="preserve"
   width="682.66669"
   height="682.66669"
   viewBox="0 0 682.66669 682.66669"
   xmlns="http://www.w3.org/2000/svg"
   xmlns:svg="http://www.w3.org/2000/svg"><defs
     id="defs4051"><clipPath
       clipPathUnits="userSpaceOnUse"
       id="clipPath4061"><path
         d="M 0,512 H 512 V 0 H 0 Z"
         id="path4059" /></clipPath></defs><g
     id="g4053"
     transform="matrix(1.3333333,0,0,-1.3333333,0,682.66667)"><g
       id="g4055"><g
         id="g4057"
         clip-path="url(#clipPath4061)"><g
           id="g4063"
           transform="translate(127.2759,345.4316)"><path
             d="m 0,0 16.441,-14.614 c 2.826,-2.512 7.209,-1.996 9.375,1.101 l 24.596,35.178"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path4065" /></g><g
           id="g4067"
           transform="translate(127.2759,235.8721)"><path
             d="m 0,0 16.441,-14.615 c 2.826,-2.511 7.209,-1.996 9.375,1.101 l 24.596,35.179"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path4069" /></g><g
           id="g4071"
           transform="translate(127.2759,127.7832)"><path
             d="m 0,0 16.441,-14.614 c 2.826,-2.512 7.209,-1.996 9.375,1.101 l 24.596,35.178"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path4073" /></g><g
           id="g4075"
           transform="translate(221.1846,363.1562)"><path
             d="M 0,0 H 105.991"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path4077" /></g><g
           id="g4079"
           transform="translate(221.1846,329.8252)"><path
             d="M 0,0 H 105.991"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path4081" /></g><g
           id="g4083"
           transform="translate(221.1846,256)"><path
             d="M 0,0 H 105.991"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path4085" /></g><g
           id="g4087"
           transform="translate(221.1846,222.6689)"><path
             d="M 0,0 H 52.995"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path4089" /></g><g
           id="g4091"
           transform="translate(410.4531,367.5)"><path
             d="m 0,0 v 60.947 c 0,9.11 -7.385,16.494 -16.494,16.494 h -83.724"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path4093" /></g><g
           id="g4095"
           transform="translate(144.2163,444.9414)"><path
             d="m 0,0 h -83.725 c -9.108,0 -16.493,-7.385 -16.493,-16.494 v -404.453 c 0,-9.11 7.385,-16.494 16.493,-16.494 h 333.468 c 9.109,0 16.494,7.384 16.494,16.494 v 191.089"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path4097" /></g><g
           id="g4099"
           transform="translate(259.8984,480.8457)"><path
             d="m 0,0 v 0 c 0,13.064 -10.591,23.654 -23.654,23.654 h -18.037 c -13.064,0 -23.654,-10.59 -23.654,-23.654 0,-6.627 -5.373,-12 -12,-12 h -14.433 c -13.202,0 -23.904,-10.702 -23.904,-23.904 v -12.558 c 0,-6.267 5.08,-11.346 11.346,-11.346 H 38.99 c 6.267,0 11.347,5.079 11.347,11.346 v 12.558 C 50.337,-22.702 39.635,-12 26.433,-12 H 12 C 5.372,-12 0,-6.627 0,0 Z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path4101" /></g><g
           id="g4103"
           transform="translate(79.7036,444.9414)"><path
             d="m 0,0 v -386.128 c 0,-6.009 4.871,-10.879 10.88,-10.879 h 111.658"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path4105" /></g><g
           id="g4107"
           transform="translate(374.748,322.8437)"><path
             d="M 0,0 V 122.098"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path4109" /></g><g
           id="g4111"
           transform="translate(265.3369,48.1592)"><path
             d="M 0,0 -31.135,-0.225 H 98.531 c 6.009,0 10.88,4.871 10.88,10.879 v 111.812"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path4113" /></g><g
           id="g4115"
           transform="translate(399.4453,314.3691)"><path
             d="m 0,0 -170.156,-212.302 -27.048,-54.314 c -2.197,-4.413 -1.021,-9.76 2.825,-12.843 3.846,-3.082 9.321,-3.066 13.149,0.039 l 47.122,38.227 170.155,212.301"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path4117" /></g><g
           id="g4119"
           transform="translate(265.7705,73.3076)"><path
             d="M 0,0 -36.247,29.052"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path4121" /></g><g
           id="g4123"
           transform="translate(459.3486,352.1758)"><path
             d="m 0,0 v 0 c -9.954,7.979 -24.491,6.377 -32.47,-3.578 l -27.433,-34.229 36.047,-28.891 27.434,34.229 C 11.556,-22.515 9.954,-7.978 0,0 Z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path4125" /></g></g></g></g></svg>
</template>
